import { render, staticRenderFns } from "./receivablesList.vue?vue&type=template&id=4649f249"
import script from "./receivablesList.vue?vue&type=script&lang=js"
export * from "./receivablesList.vue?vue&type=script&lang=js"
import style0 from "./receivablesList.vue?vue&type=style&index=0&id=4649f249&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports